import { useAction, useAtom } from '@reatom/npm-react'
import BigNumber from 'bignumber.js'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, ReferralWithdrawIcon } from '@blade/ui-kit'
import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { referralInfoAtom } from '@root/entities/referral'
import { openReferralWithdrawFlowEvent } from '@root/features/referral/atoms'
import { AmountFormatted } from '@root/shared/core/format'
import { ChevronRightTallIcon } from '@root/shared/ui-kit'

import { ReferralCard } from './referral-card-common'

type ReferralCodeCardProps = {}

export const ReferralCardWithdraw: React.FC<ReferralCodeCardProps> = () => {
  const { t } = useTranslation()
  const [referralInfo] = useAtom(referralInfoAtom)
  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)
  const balanceNative = referralInfo?.referralBalanceNative ?? BigNumber(0)
  const openReferralWithdrawFlow = useAction(openReferralWithdrawFlowEvent)

  return (
    <>
      <ReferralCard>
        <ReferralCard.Header>
          <Icon icon={ReferralWithdrawIcon} />
          <ReferralCard.Title>{t('referral.earnings')}</ReferralCard.Title>
          {balanceNative.isZero() ? undefined : (
            <Button
              radius="full"
              size="h24"
              variant="solid"
              color="primary"
              iconLeft={<ChevronRightTallIcon />}
              onClick={() => {
                openReferralWithdrawFlow()
              }}
            />
          )}
        </ReferralCard.Header>
        <ReferralCard.Content>
          <Count data-has-data={!balanceNative.isZero()}>
            <AmountFormatted
              amount={balanceNative}
              currency={nativeCurrency.ticker}
              roundingMode="trunc"
            />
          </Count>
        </ReferralCard.Content>
      </ReferralCard>
    </>
  )
}

const Icon = styled(ReferralCard.Icon)`
  color: var(--purple-9);
`

const Count = styled.span`
  color: var(--text-9);
  font-size: 18px;
  font-weight: 700;
  line-height: 20px; /* 111.111% */
  margin-right: 6px;

  &[data-has-data='true'] {
    color: var(--text-12);
  }
`
